import React, { useEffect, useState } from 'react';
import { Form, Modal, Typography, message } from 'antd';
import api from '../api';
import ScheduleVarianceFields, { toVarianceBody } from './ScheduleVarianceFields';

export default function ScheduleVarianceCreateModal({ open, currentUser, onClose, onCreated }) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    form.resetFields();
    form.setFieldsValue({ remove_points: 'N/A', status: 'Open' });
  }, [open]); // eslint-disable-line

  const handleCreate = async () => {
    let values;
    try { values = await form.validateFields(); } catch { return; }
    setSaving(true);
    try {
      const res = await api.post('/api/schedule-variances', toVarianceBody(values));
      message.success('Schedule variance logged.');
      onCreated?.(res.data.id);
    } catch (err) {
      message.error(err.response?.data?.error || 'Failed to log schedule variance.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal maskClosable={false}
      title="Log Schedule Variance"
      open={open}
      onCancel={onClose}
      onOk={handleCreate}
      confirmLoading={saving}
      okText="Submit"
      destroyOnClose
      width={680}
    >
      <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
        Reporter: <Typography.Text strong>{currentUser?.DisplayName}</Typography.Text>
      </Typography.Text>
      <Form form={form} layout="vertical">
        <ScheduleVarianceFields form={form} open={open} />
      </Form>
    </Modal>
  );
}
